define.alias("shared/components/shared/social/refresh-profile/base-button", "calendar/components/shared/social/refresh-profile/base-button");